const Home = () => {
  return (
    <div className="about-home">
      <div className="about-home-content md:px-28 px-10">
        {/* Heading */}
        <h1 className="md:text-2xl text-xl font-normal text-pink-600">
          RemoteWebNET <br /> Dynamics Ltd
        </h1>
        <div className="text-white border-t border-t-white mt-8 pt-4">
          <h1 className="uppercase font-normal text-xl"></h1>
          <p className="font-normal capitalize text-lg">Integrity | Results</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
